import React from 'react'

// Self-contained stroke icons — these replace the SVGs that were hotlinked
// from barakahit.net. currentColor keeps them usable on light and dark surfaces.

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

const Svg = ({ className = 'h-7 w-7', children }) => (
  <svg {...base} className={className} aria-hidden="true">
    {children}
  </svg>
)

const paths = {
  code: (
    <>
      <path d="M9.2 8.4 5.6 12l3.6 3.6M14.8 8.4 18.4 12l-3.6 3.6" />
      <path d="M13.1 6.2 10.9 17.8" />
      <rect x="2.5" y="3.5" width="19" height="17" rx="3" />
    </>
  ),
  bolt: (
    <>
      <path d="M12.8 2.5 5.4 13.1h5.3l-.5 8.4 7.4-10.6h-5.3z" />
    </>
  ),
  camera: (
    <>
      <path d="M3.5 8.4h2.9l1.6-2.6h8l1.6 2.6h2.9a1.5 1.5 0 0 1 1.5 1.5v8.1a1.5 1.5 0 0 1-1.5 1.5H3.5A1.5 1.5 0 0 1 2 18V9.9a1.5 1.5 0 0 1 1.5-1.5Z" />
      <circle cx="12" cy="13.6" r="3.5" />
    </>
  ),
  support: (
    <>
      <path d="M4.2 14.5v-2.6a7.8 7.8 0 0 1 15.6 0v2.6" />
      <rect x="2" y="13.4" width="4.2" height="6" rx="2.1" />
      <rect x="17.8" y="13.4" width="4.2" height="6" rx="2.1" />
      <path d="M19.8 19.4v.4a2.4 2.4 0 0 1-2.4 2.4H13" />
    </>
  ),
  palette: (
    <>
      <path d="M12 21.2a9.2 9.2 0 1 1 9.2-9.2c0 2.1-1.7 3.1-3.4 3.1h-1.9a2.2 2.2 0 0 0-1.7 3.6c.5.6.1 2.5-2.2 2.5Z" />
      <circle cx="7.6" cy="12.4" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="9.9" cy="8.2" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="14.6" cy="8.2" r="1.1" fill="currentColor" stroke="none" />
    </>
  ),
  devices: (
    <>
      <path d="M14.4 17.4H3.6A1.6 1.6 0 0 1 2 15.8V5.6A1.6 1.6 0 0 1 3.6 4h13.9A1.6 1.6 0 0 1 19 5.6v2.1" />
      <path d="M7.4 20.6h5.6" />
      <rect x="16.4" y="9.6" width="5.6" height="11" rx="1.6" />
      <path d="M18.8 18h.8" />
    </>
  ),
  layers: (
    <>
      <path d="m12 2.8 9 4.9-9 4.9-9-4.9z" />
      <path d="m3 12.4 9 4.9 9-4.9" />
      <path d="m3 16.9 9 4.9 9-4.9" />
    </>
  ),
  document: (
    <>
      <path d="M13.6 2.6H6.8a2 2 0 0 0-2 2v14.8a2 2 0 0 0 2 2h10.4a2 2 0 0 0 2-2V8.2z" />
      <path d="M13.6 2.6v5.6h5.6" />
      <path d="M8.6 13.4h6.8M8.6 17h4.4" />
    </>
  ),
  shield: (
    <>
      <path d="M12 2.4 4.4 5.6v6c0 4.5 3.1 8.7 7.6 10 4.5-1.3 7.6-5.5 7.6-10v-6z" />
      <path d="m8.8 11.8 2.3 2.4 4.1-4.4" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9.2" />
      <path d="m15.4 8.6-1.9 5-5 1.9 1.9-5z" />
    </>
  ),
  phone: (
    <>
      <path d="M21.5 16.9v2.8a1.9 1.9 0 0 1-2.1 1.9 18.6 18.6 0 0 1-8.1-2.9 18.3 18.3 0 0 1-5.6-5.6A18.6 18.6 0 0 1 2.8 5a1.9 1.9 0 0 1 1.9-2.1h2.8a1.9 1.9 0 0 1 1.9 1.6c.1 1 .35 1.9.7 2.8a1.9 1.9 0 0 1-.4 2l-1.2 1.2a15 15 0 0 0 5.6 5.6l1.2-1.2a1.9 1.9 0 0 1 2-.4c.9.35 1.8.6 2.8.7a1.9 1.9 0 0 1 1.6 1.9Z" />
    </>
  ),
  mail: (
    <>
      <rect x="2.4" y="4.6" width="19.2" height="14.8" rx="2.2" />
      <path d="m3.4 6.6 8.6 6 8.6-6" />
    </>
  ),
  pin: (
    <>
      <path d="M19.4 10.4c0 5.5-7.4 11-7.4 11s-7.4-5.5-7.4-11a7.4 7.4 0 1 1 14.8 0Z" />
      <circle cx="12" cy="10.2" r="2.7" />
    </>
  ),
  arrow: (
    <>
      <path d="M4.8 12h14.4M13.4 6.2 19.2 12l-5.8 5.8" />
    </>
  ),
  check: (
    <>
      <path d="m4.8 12.6 4.6 4.6L19.2 7.4" />
    </>
  ),
}

const Icon = ({ name, className }) => {
  const glyph = paths[name]
  if (!glyph) return null
  return <Svg className={className}>{glyph}</Svg>
}

export default Icon
